import React, { useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import Menu from '../menu/Menu';
import GlobalFilters from './GlobalFilters';
import { Button } from 'primereact/button';
import SearchFiles from '../search/SearchFiles';
import { chipItems } from '../../../constants/fileManagerConstants';

const GlobalFileManagerFilter = ({ setFileManagerFilters, fileManagerFilters }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => document.documentElement.getAttribute('data-theme') === 'dark');
  const history = useHistory();

  const handleChipClick = (chipValue) => {
    setFileManagerFilters((prev) => {
      const baseFilters = {
        ...prev,
        is_client_uploaded: '',
        is_read: '',
        esignature_status: '',
        uploadedBy: '',
        forceCaseUndefined: false,
        isFirmUploads: false,
      };

      switch (chipValue) {
        case 'uploads':
          return {
            ...baseFilters,
            is_client_uploaded: true,
            uploadedBy: 'client',
          };

        case 'unread':
          return {
            ...baseFilters,
            is_read: false,
          };

        case 'signed':
          return {
            ...baseFilters,
            esignature_status: 'SIGNED',
          };

        case 'all':
        default:
          return baseFilters;
      }
    });
  };

  // Update active tab index when filters change
  const activeTabIndex = useMemo(() => {
    if (fileManagerFilters?.esignature_status === 'SIGNED') return 3;
    if (fileManagerFilters?.is_read === false) return 2;
    if (fileManagerFilters?.is_client_uploaded === true || fileManagerFilters?.uploadedBy === 'client') return 1;
    return 0;
  }, [
    fileManagerFilters?.esignature_status,
    fileManagerFilters?.is_read,
    fileManagerFilters?.is_client_uploaded,
    fileManagerFilters?.uploadedBy,
  ]);

  // Detect theme changes
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
      setIsDarkMode((prev) => (prev !== isDark ? isDark : prev));
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme'],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-between mb-3 p-3 border-round-lg gap-3 flex-wrap"
        style={{
          backgroundColor: isDarkMode ? 'rgba(45, 55, 72, 0.3)' : '#f8f9fa',
          border: isDarkMode ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #e9ecef',
          borderRadius: '8px',
        }}
      >
        <div>
          <h5 className="mb-1 text-900" style={{ fontSize: '16px', fontWeight: '600' }}>
            Firm Documents
          </h5>
          <p className="mb-0 text-600" style={{ fontSize: '14px' }}>
            Upload firm-wide documents that will be shared with the entire firm
          </p>
        </div>
        <div className="d-flex gap-2">
          <Button
            label="View Firm Documents"
            className="p-button p-button-primary"
            onClick={() => {
              history.push('/file-manager/firm-documents');
            }}
          />
        </div>
      </div>

      <div className="mb-md-3">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
          <div className="d-flex gap-2 flex-wrap">
            {chipItems.map((item, index) => (
              <Button
                key={item.value}
                label={item.label}
                className={`p-button p-button-sm ${activeTabIndex === index ? 'p-button-primary' : 'p-button-primary outline'}`}
                style={{
                  borderRadius: '20px',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
                onClick={() => handleChipClick(item.value, index)}
              />
            ))}
          </div>

          <div className="d-none d-md-block" style={{ minWidth: '250px', maxWidth: '350px', flexShrink: 0 }}>
            <SearchFiles />
          </div>
        </div>
      </div>

      <div className="mb-4">
        <GlobalFilters />
      </div>

      <div className="d-flex align-items-center justify-content-end w-100 mt-2">
        <Menu />
      </div>
    </>
  );
};

export default GlobalFileManagerFilter;
